import PageIcon from '@atlaskit/icon/core/page';
import * as React from 'react';

export function SvgWriteDocument() {
  return <PageIcon label="" testId="ads-refreshed-icon" />;
}
